const fallbackPalettes = [
  { primary: '#b91c1c', secondary: '#111827', text: '#fff7ed' },
  { primary: '#f59e0b', secondary: '#111827', text: '#111827' },
  { primary: '#15803d', secondary: '#facc15', text: '#f7fee7' },
  { primary: '#1d4ed8', secondary: '#f8fafc', text: '#eff6ff' },
  { primary: '#7c2d12', secondary: '#fdba74', text: '#fff7ed' },
  { primary: '#581c87', secondary: '#c084fc', text: '#faf5ff' },
  { primary: '#0f766e', secondary: '#99f6e4', text: '#ecfeff' },
  { primary: '#be123c', secondary: '#fda4af', text: '#fff1f2' },
  { primary: '#374151', secondary: '#e5e7eb', text: '#f9fafb' },
  { primary: '#0369a1', secondary: '#7dd3fc', text: '#f0f9ff' },
  { primary: '#a16207', secondary: '#fde68a', text: '#fffbeb' },
  { primary: '#166534', secondary: '#dcfce7', text: '#f0fdf4' },
];

const clubPalettes = {
  'greenwich borough': { primary: '#0f5132', secondary: '#f8fafc', text: '#ecfdf5' },
  'liverpool': { primary: '#c8102e', secondary: '#111827', text: '#fff1f2' },
  'ashford town': { primary: '#f97316', secondary: '#111827', text: '#111827' },
  'atherstone town': { primary: '#b91c1c', secondary: '#f8fafc', text: '#fff1f2' },
  'avonmouth': { primary: '#dc2626', secondary: '#111827', text: '#fff1f2' },
  'bedfont': { primary: '#b91c1c', secondary: '#facc15', text: '#fff1f2' },
  'boston town': { primary: '#f59e0b', secondary: '#111827', text: '#111827' },
  'brook house': { primary: '#7f1d1d', secondary: '#111827', text: '#fff1f2' },
  'castle cary': { primary: '#facc15', secondary: '#111827', text: '#111827' },
  'chadderton': { primary: '#c8102e', secondary: '#f8fafc', text: '#fff1f2' },
  'cirencester town': { primary: '#b91c1c', secondary: '#111827', text: '#fff1f2' },
  'coalville town': { primary: '#dc2626', secondary: '#f8fafc', text: '#fff1f2' },
  'coventry united': { primary: '#16a34a', secondary: '#dc2626', text: '#f0fdf4' },
  'holland': { primary: '#1d4ed8', secondary: '#facc15', text: '#eff6ff' },
  'holmer green': { primary: '#15803d', secondary: '#f8fafc', text: '#f0fdf4' },
  'new bradwell st peter': { primary: '#15803d', secondary: '#f8fafc', text: '#f0fdf4' },
  'nuneaton town': { primary: '#1d4ed8', secondary: '#f8fafc', text: '#eff6ff' },
  'retford united': { primary: '#dc2626', secondary: '#111827', text: '#fff1f2' },
  'steyning town': { primary: '#facc15', secondary: '#1d4ed8', text: '#111827' },
  'td shipley': { primary: '#0f766e', secondary: '#111827', text: '#ecfeff' },
};

function normalizeClubName(clubName) {
  return String(clubName || '')
    .split(',')[0]
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/\([^)]*\)/g, '')
    .replace(/\b(fc|afc|cfc|first team|firsts|first|reserves|res|u21|under 21)\b/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

function hashString(value) {
  return String(value || '').split('').reduce((hash, char) => {
    return ((hash << 5) - hash + char.charCodeAt(0)) | 0;
  }, 0);
}

function hexToRgb(hex) {
  const value = hex.replace('#', '');
  const bigint = parseInt(value, 16);
  return {
    r: (bigint >> 16) & 255,
    g: (bigint >> 8) & 255,
    b: bigint & 255,
  };
}

function withAlpha(hex, alpha) {
  const { r, g, b } = hexToRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function getClubAvatarStyle(clubName) {
  if (!clubName) return null;

  const normalized = normalizeClubName(clubName);
  const palette = clubPalettes[normalized] || fallbackPalettes[Math.abs(hashString(normalized)) % fallbackPalettes.length];

  return {
    background: `linear-gradient(135deg, ${palette.primary} 0%, ${palette.primary} 62%, ${palette.secondary} 100%)`,
    color: palette.text,
    borderColor: withAlpha(palette.secondary, 0.55),
    boxShadow: `0 0 0 1px ${withAlpha(palette.primary, 0.18)}, 0 8px 20px ${withAlpha(palette.primary, 0.16)}`,
  };
}
